import React, { useRef, useEffect, useState } from 'react';

import MaterialTable from 'material-table';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes} from '@fortawesome/free-solid-svg-icons';
import '../../scss/components/_file_list.scss';
import TableIcons from '../TableIcons';

import API_PATH from "../../constants/config.json";import Cookies from 'js-cookie';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const AWS = require('aws-sdk');

const fileTypesAllowed = ['txt', 'pdf', 'csv', 'xlsx', 'prn'];
const videoTypesAllowed = ['mp4', 'mkv', 'avi'];
const imageTypesAllowed = ['png', 'jpg', 'jpeg', ''];

const FileList = props => {
    const [anchorElDetailsMenu, setanchorElDetailsMenu] = React.useState(null);
    const openDetailsMenu = Boolean(anchorElDetailsMenu);
    const [idintityPool, setIdintityPool] = React.useState('');
    const [aswLogins, setAswLogins] = React.useState('');
    const [openDeleteOotions, setOpenDeleteOotions] = React.useState(false); 
    const [myFileID, setMyFileId] = React.useState(null);   
    const [scrolled, setScrolled] = useState(false);
    const [loader, setloader] = useState({loader:false});
    const tableRef = useRef();
    const handleCloseDeleteOotions = () => setOpenDeleteOotions(false);

    const [files, setFiles] = React.useState([]);
    const [hover, setHower] = React.useState(false);
    const refContainer = useRef('');

    useEffect(() => {
      addFields(props.list);
      setFiles(props.list);
    }, [props.list])

    useEffect(() => {
      getAswToken();
    }, [])

    const addFields = (files) =>{
      for (let i = 0; i < files.length; i++) {
        files[i].file_type = setFileType(files[i].origin_name);
        files[i].fk_file_type_id = setType(files[i].FK_file_type_id);
        files[i].public = setPublic(files[i].is_public);
      }
    }

    const setFileType = (file) => {
      const _split = file.split('\.');
      let type = _split[_split.length - 1].toLowerCase();
      if (fileTypesAllowed.find(e => e == type))
        return type;
      else {
        if (videoTypesAllowed.find(e => e == type))
          return 'video';
        else if (imageTypesAllowed.find(e => e == type))
          return 'image';
        else
          return 'file';
      }
    }

    const setType = (FK_file_type_id) =>{
      if (FK_file_type_id === 5)
        return "Storage";
      else
        return "Imported";
    }

    const setPublic = (is_public) =>{
      if (is_public)
        return "A";
      else
        return "B";
    }

    const searchField = (value) => {
      setHower(true);
      let newData = [];
      value = value.toLowerCase();
      props.list.forEach(function (e) {
        const _search = e['origin_name'];
        if (_search.toLowerCase().indexOf(value) >= 0) {
          newData.push(e);
        }
      });
      setFiles(newData);
    }

    const clearText = () => {
      refContainer.current.reset();
      setFiles(props.list);
    }

    const handleOpenDeleteOotions = (file_id) => {        
        setMyFileId(file_id);
        setOpenDeleteOotions(true);
    }

    const handleClickDetailsMenu = (event) => {        
        setanchorElDetailsMenu(event.currentTarget);
    };
    const handleCloseDetailsMenu = () => {
        setanchorElDetailsMenu(null);
    }
    const getAswToken = () => {
        try {
          axios({
            method: 'get',
            url: API_URL + API_PATH.getAWSs3TokenAPI,
            headers: {
              'agencyid': sessionStorage.getItem('agency_id'),
              'payload': Cookies.get('payload'),
            },
          }).then(async function (response) {
            if (response.status && response.status == '200') {
              let aswData = response.data;
              setIdintityPool(aswData.data.IdentityPoolId);
              setAswLogins(aswData.data.Logins);
            } else {
              console.log("");
            }
          })
        } catch (error) {
          console.error(error);
        }
    }
    const downloadFile = (file_id, bucketName, filename, originalFileName) => {
        setloader({ filename: file_id, loader: true });
        handleCloseDetailsMenu();
        let OIDToken = Cookies.get('idToken');
        AWS.config.update(
          {
            region: 'us-west-2',
            credentials: new AWS.CognitoIdentityCredentials({
              IdentityPoolId: idintityPool,
              Logins: {
                [aswLogins]: OIDToken
              }
            })
          }
        );
        // formatting bucketname and filename correctly 
        let tmp = filename.split('/');
        for(let z=0; z < tmp.length -1; z++) {
          bucketName += "/"+tmp[z];
        }
        filename = tmp[tmp.length-1];

        let s3 = new AWS.S3();
        s3.headObject({ Bucket: bucketName, Key: filename }, function (
          error,
          data
        ) {            
          if (error != null) {
            //handleOpenDialogueBox();
            loader.loader = false
            setloader(loader);
          } else {
            s3.getSignedUrl('getObject', {
              Bucket: bucketName,
              Key: filename,
              Expires: 86400,
              ResponseContentDisposition :  `attachment; filename="${originalFileName}"`
            },function (error, url) {
                if (error != null) {
                    // setErrorText("File Downloading Failed!");
                    // handleOpenDialogueBox();
                } else {       
                  // let blob = new Blob([data.Body], { type: data.ContentType });
                  let link = document.createElement("a");
                  link.href = url;
                  link.target='_blank';
                  link.download = originalFileName;
                  link.click();
                  loader.loader = false
                  setloader(loader);
                }
            });
          }
        });
    };
    const shareFile = (file_id,shared) =>{
      handleCloseDeleteOotions(); 
      handleCloseDetailsMenu();   
      try {
        axios({
          method: 'post',
          url: API_URL + API_PATH.publicFile,
          data : {
            "file_id": [file_id],
            "is_public": shared
          },
          headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
          },
        })
          .then(async function (response) {
            if (response.status && response.status == '200') {
              props.getFileList();
              handleCloseDeleteOotions(); 
              handleCloseDetailsMenu();                        
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } catch (error) {
        console.error(error);
      }

    }
    const rejectFile = () => {  
        handleCloseDeleteOotions(); 
        handleCloseDetailsMenu();        
        //props.getFileList();     
        try {
          axios({
            method: 'post',
            url: API_URL + API_PATH.rejectFile + myFileID,
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                props.getFileList();
                handleCloseDeleteOotions(); 
                handleCloseDetailsMenu();                        
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } catch (error) {
          console.error(error);
        }
        //setOpen(false);
    }
    const handleScroll = () => {
      if (tableRef.current) {
        const { scrollTop } = tableRef.current.children[0].children[0].children[0].children[0].children[0].children[0].children[1];
        if (scrollTop > 0) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      }
    };

    const validDownloadLink = (rowData) => {
      let valid = true;
      if(rowData.bucket_name === 'N/A' || !rowData.bucket_name || rowData.bucket_name === '' || rowData.bucket_name === 'myQC Direct Migration' || rowData.origin_name.indexOf("myQC SiteNumber") >= 0) {
        valid = false;
      }
      return valid;
    }

    return (
        <React.Fragment>
          <div className="table-top">
                <h3>Files</h3>
                <form ref={refContainer} noValidate autoComplete="off">
                    <TextField
                    id="input-with-icon-textfield"
                    placeholder="Search files names"
                    onChange={(e) => searchField(e.target.value)}
                    //onKeyPress={(e) => kekPressSearch(e)}
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start" /* onClick={onSearch} */>
                            <SearchIcon style={{ cursor: 'pointer' }} />
                        </InputAdornment>
                        ),
                        endAdornment: (
                        <InputAdornment position="end">
                            {hover && <FontAwesomeIcon icon={faTimes} onClick={clearText} />}
                        </InputAdornment>
                        ),
                    }}

                    />      
                    
                </form>
            </div>
          <div className={scrolled ? "table-container scrolled-el" : "table-container"} /* onScroll={handleScroll} ref={tableRef} */>
            <MaterialTable  
                icons={TableIcons}  
                className='tb-files-info'                
                    options={{
                      search:false,
                      paging:false,
                      toolbar:false,
                      sorting:true,
                      draggable: false
                    }}                    
                    columns={[
                      {
                        title: '', field: 'file_type', width: '5%', cellStyle: { color: '#71717A', fontSize: '14px', justifyContent:'center' }, headerStyle:{
                        },
                        render: rowData =>
                          <span className={rowData.file_type==='empty' ? '' : 'rw-file-shared-filetype'} style={{paddingLeft:0}}><img src={require(`../../assets/icons/file_types/${rowData.file_type === 'prn' ? "_"+rowData.file_type : rowData.file_type}.svg`)} /></span>
                      },
                        { title: 'File name', field: 'origin_name',width: '41%', cellStyle:{color: '#2563EB',fontSize: '14px'}, customSort:(a,b)=>{
                          const nameA = a.origin_name.toUpperCase();
                          const nameB = b.origin_name.toUpperCase();
                          if (nameB < nameA)
                            return -1;
                          if (nameB > nameA)
                            return 1;
                          return 0;
                        },
                          render: rowData =>                             
                            !validDownloadLink(rowData) ?
                              <div title={rowData.origin_name} className='td-file-name'>
                                {rowData.origin_name}
                              </div> 
                              :
                              <div title={rowData.origin_name} className='td-file-name-link' onClick={() => downloadFile(rowData.file_id, rowData.bucket_name, rowData.base_name, rowData.origin_name)}>
                                {loader.filename === rowData.file_id && loader.loader ? <CircularProgress /> : null}
                                {rowData.origin_name}
                              </div> 
                        },
                        { title: '', field: 'public',width: '4%',cellStyle:{color: '#71717A',fontSize: '14px', justifyContent:'center'},
                            render: rowData => {
                              return <>
                              {rowData.is_public?<span className='rw-file-shared'><img src={require('../../assets/icons/lock_open.svg')} /></span>:<span className='rw-file-unshared'><img src={require('../../assets/icons/lock_close.svg')} /></span>}
                              </>
                            }
                        },
                        { title: 'Type', field: 'fk_file_type_id',width: '10%',cellStyle:{color: '#71717A',fontSize: '14px', justifyContent:'center'},
                            render: rowData => rowData.FK_file_type_id === 5 ?<span className='list-file-storage'>Storage</span>:<span className='list-file-imported'>Imported</span>,
                        },
                        { title: 'Date imported', field: 'createdAt',width: '13%',cellStyle:{color: '#71717A',fontSize: '14px', justifyContent:'center'}, sorting : false,
                            render: rowData => {
                                var d = new Date(rowData.createdAt);
                                return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
                            }
                        },                        
                        { title: 'Imported by', field: 'imported_by',width: '20%',cellStyle:{color: '#71717A',fontSize: '14px', justifyContent:'center'},sorting : false, 
                          render: rowData => <div title={rowData.imported_by} className='td-file-imported-by'>
                            {rowData.imported_by}
                          </div>}, 
                        { title: 'Action',width: '6%',cellStyle:{textAlign:'center',padding: '0px', justifyContent:'center'}, sorting : false, render: rowData => {                            
                            return <>
                                <IconButton
                                    aria-label="more"
                                    id={"filen-button-"+rowData.file_id}
                                    aria-controls={"filen-menu-"+rowData.file_id}
                                    aria-expanded={openDetailsMenu ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={handleClickDetailsMenu}
                                    style={{padding:'0px'}}
                                    disabled={!validDownloadLink(rowData)}
                                >
                                    <MoreVertIcon />
                                </IconButton>
                                <Menu                        
                                    id={"filen-menu-"+rowData.file_id}
                                    MenuListProps={{
                                    'aria-labelledby': "filen-button-"+rowData.file_id,
                                    'class':'menu-details-pnl'
                                    }}
                                    anchorEl={anchorElDetailsMenu}
                                    open={(openDetailsMenu && anchorElDetailsMenu.id == 'filen-button-'+rowData.file_id)?true : false}
                                    onClose={handleCloseDetailsMenu}
                                    PaperProps={{
                                    style: {
                                        maxHeight: 48 * 4.5,
                                        maxWidth: '176px',
                                        padding:'0px',
                                        background: '#FFFFFF',
                                        borderRadius: '6px',
                                        boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)'
                                    },
                                    }}
                                >
                                    <MenuItem key={0} onClick={() => downloadFile(rowData.file_id, rowData.bucket_name, rowData.base_name, rowData.origin_name)}>
                                    <img src={require('../../assets/icons/download_file.svg')}  /> Download
                                    </MenuItem>
                                    {
                                      !props.sharedStation &&
                                      <>
                                      <MenuItem key={1} onClick={() => shareFile(rowData.file_id,!rowData.is_public)}>
                                      <img src={require('../../assets/icons/file-icon-share.svg')}  /> {rowData.is_public?<>{API_PATH.unsharedWording}</>:<>{API_PATH.sharedWording}</>}
                                      </MenuItem>
                                      <MenuItem key={2} onClick={() => handleOpenDeleteOotions(rowData.file_id)}>
                                      <img src={require('../../assets/icons/delete_file.svg')}  /> Delete
                                      </MenuItem>                                    
                                      </>
                                    }
                                </Menu>
                            </>
                        } }
                    ]}
                    data={files}
                    localization={{
                        body: {
                            emptyDataSourceMessage: (
                                <>
                                    <div className="info-no-data-pn" style={{}}>
                                        <img src={require('../../assets/icons/no_files.svg')}  />                            
                                        <label className='title-no-data'>No files here</label>
                                        <label className='title-no-data-more'>Once you upload some files to this station they will appear here!</label>
                                    </div>
                                </>
                            ),
                        },
                    }}
            />
          </div>
                <Modal
                    open={openDeleteOotions}
                    onClose={handleCloseDeleteOotions}
                    aria-labelledby="Delete File"
                    aria-describedby="Options to delete files ..."            
                >
                    <div className='md-delete-file-opt'>
                        <Grid container>  
                            <Grid item xs={1} className='md-delete-icon'>
                                <img src={require('../../assets/icons/warning-delete-file.svg')} />
                            </Grid> 
                            <Grid item xs={11} className='md-delete-body'>
                                <div className='md-delete-title'>
                                    Delete File
                                </div>
                                <div className='md-delete-question'>
                                    Are you want to delete this file? Once the file is deleted there is no way to recover or restore it.
                                </div>
                                <div className='md-delete-actions'>
                                    <Button className='md-delete-actions-cancel' onClick={handleCloseDeleteOotions}>Cancel</Button> 
                                    <Button className='md-delete-actions-delete' onClick={rejectFile}>Delete</Button>
                                </div>
                            </Grid> 
                        </Grid> 
                    </div>
                </Modal>

        </React.Fragment>
    )
}

export default FileList;